import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderOwnershipSummary } from '../../types/stakeholder.types';
import { useAppQuery } from '../use-app-query.hook';

export const useOwnershipSummary = ({
  companyId,
  enabled = true,
  stakeholderId,
}: {
  companyId: string;
  enabled?: boolean;
  stakeholderId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: ownershipSummary, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_STAKEHOLDER_OWNERSHIP_SUMMARY, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<StakeholderOwnershipSummary>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'ownership-summary'],
      }),
    enabled: enabled && !!companyId && !!stakeholderId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_STAKEHOLDER_OWNERSHIP_SUMMARY] });
  }, [queryClient]);

  return {
    invalidateQuery,
    ownershipSummary,
    isLoading,
  };
};
